// @ts-nocheck
  (function () {
    var scriptEl = document.currentScript;
    var SID = scriptEl && scriptEl.dataset ? scriptEl.dataset.sectionId : null;
    var currency_symbol = scriptEl && scriptEl.dataset ? (scriptEl.dataset.currencySymbol || '') : '';
    var sectionRoot = SID ? document.querySelector('[data-cc-child-collection][data-section-id=\"' + SID + '\"]') : null;
    if (!sectionRoot) sectionRoot = document;
    if (!SID) return;

    var state = {
      sort: 'featured',
      sizes: [],
      colors: [],
      priceRanges: [],
      lowestPrice: false,
    };

    function syncStateFromDOM() {
      var sectionWrap = grid ? grid.closest('.cc-page') : document;
      var sortRadio = sectionWrap.querySelector('[data-sort]:checked');
      if (sortRadio) state.sort = sortRadio.value;

      state.sizes = Array.from(sectionWrap.querySelectorAll('[data-filter-type="size"]:checked')).map(function (cb) { return cb.value; });
      state.colors = Array.from(sectionWrap.querySelectorAll('[data-filter-type="color"]:checked')).map(function (cb) { return cb.value; });
      state.priceRanges = Array.from(sectionWrap.querySelectorAll('[data-filter-type="price-range"]:checked')).map(function (cb) { return cb.value; });
      state.lowestPrice = !!sectionWrap.querySelector('[data-filter-type="lowest-price"]:checked');
    }

    function syncStateFromURL() {
      var params = new URLSearchParams(window.location.search);
      var sectionWrap = grid ? grid.closest('.cc-page') : document;

      // Sort
      var urlSort = params.get('sort');
      if (urlSort) {
        state.sort = urlSort;
        var radio = sectionWrap.querySelector('[data-sort][value="' + urlSort + '"]');
        if (radio) radio.checked = true;
      }

      // Sizes
      var urlSizes = params.get('size');
      if (urlSizes) {
        state.sizes = urlSizes.split(',');
        sectionWrap.querySelectorAll('[data-filter-type="size"]').forEach(function (cb) {
          cb.checked = state.sizes.indexOf(cb.value) > -1;
        });
      }

      // Colors
      var urlColors = params.get('color');
      if (urlColors) {
        state.colors = urlColors.split(',');
        sectionWrap.querySelectorAll('[data-filter-type="color"]').forEach(function (cb) {
          cb.checked = state.colors.indexOf(cb.value) > -1;
        });
      }

      // Price Ranges
      var urlPrice = params.get('price');
      if (urlPrice) {
        state.priceRanges = urlPrice.split(',');
        sectionWrap.querySelectorAll('[data-filter-type="price-range"]').forEach(function (cb) {
          cb.checked = state.priceRanges.indexOf(cb.value) > -1;
        });
      }

      // Lowest Price
      var urlLowest = params.get('lowest_price');
      if (urlLowest) {
        state.lowestPrice = urlLowest === 'true';
        var lowestCb = sectionWrap.querySelector('[data-filter-type="lowest-price"]');
        if (lowestCb) lowestCb.checked = state.lowestPrice;
      }
    }

    function updateURL() {
      var params = new URLSearchParams(window.location.search);
      
      if (state.sort && state.sort !== 'featured') params.set('sort', state.sort);
      else params.delete('sort');

      if (state.sizes.length > 0) params.set('size', state.sizes.join(','));
      else params.delete('size');

      if (state.colors.length > 0) params.set('color', state.colors.join(','));
      else params.delete('color');

      if (state.priceRanges.length > 0) params.set('price', state.priceRanges.join(','));
      else params.delete('price');

      if (state.lowestPrice) params.set('lowest_price', 'true');
      else params.delete('lowest_price');

      var newUrl = window.location.pathname + '?' + params.toString();
      window.history.replaceState({ path: newUrl }, '', newUrl);
    }
    /* ── Product Card Interaction ── */
    if (!window.customElementProductCardDefined) {
       customElements.whenDefined('product-card').then(() => {
          const ProductCard = customElements.get('product-card');
          ProductCard.prototype.handleThumbClick = function(btn) {
             const isMobile = window.innerWidth < 750;
             const vImg = isMobile ? btn.dataset.vimgMobile : btn.dataset.vimg;
             const vTitle = btn.dataset.vtitle;
             const vPrice = btn.dataset.vprice;
             const vCompare = btn.dataset.vcompare;

             // Update image
             const mainImg = this.querySelector('[ref="mainImg"]');
             if (mainImg) {
               mainImg.src = vImg;
               mainImg.srcset = '';
             }
             const mainImgMob = this.querySelector('[ref="mainImgMobile"]');
             if (mainImgMob) {
               mainImgMob.src = vImg;
               mainImgMob.srcset = '';
             }

             // Update title/price
             const titleEl = this.querySelector('[ref="variantTitle"]');
             const priceEl = this.querySelector('[ref="priceVal"]');
             const compareEl = this.querySelector('[ref="comparePrice"]');
             const saleBadge = this.querySelector('[ref="saleBadge"]');
             const saleBadgeMob = this.querySelector('[ref="saleBadgeMobile"]');

             if (titleEl) titleEl.textContent = vTitle;
             if (priceEl) priceEl.textContent = vPrice;

             // Update data-price on wrapper for correct sorting/filtering
             const vPriceRaw = btn.dataset.vpriceRaw;
             const wrap = this.closest('.cc-card-wrap');
             if (wrap && vPriceRaw) wrap.dataset.price = vPriceRaw;

             // Update comparison price and sale badge
             if (vCompare && vCompare !== '' && vCompare !== '0.00') {
                if (compareEl) {
                   compareEl.textContent = vCompare;
                   compareEl.removeAttribute('hidden');
                } else {
                   const s = document.createElement('s');
                   s.className = 'cc-card__compare-price';
                   s.setAttribute('ref', 'comparePrice');
                   s.textContent = vCompare;
                   this.querySelector('[ref="priceWrap"]').appendChild(s);
                }
                if (saleBadge) saleBadge.removeAttribute('hidden');
                if (saleBadgeMob) saleBadgeMob.removeAttribute('hidden');
             } else {
                if (compareEl) compareEl.setAttribute('hidden', '');
                if (saleBadge) saleBadge.setAttribute('hidden', '');
                if (saleBadgeMob) saleBadgeMob.setAttribute('hidden', '');
             }

             // Update active state
             this.querySelectorAll('.cc-card__thumb').forEach(t => t.classList.remove('is-active'));
             btn.classList.add('is-active');

             // Update Link URLs
             this.querySelectorAll('[ref="productCardLink"]').forEach(link => {
                const url = new URL(link.href);
                url.searchParams.set('variant', btn.dataset.vid);
                link.href = url.toString();
             });

             // Update Form Variant ID
             const vIdInput = this.querySelector('[ref="variantId"]');
             if (vIdInput) vIdInput.value = btn.dataset.vid;

             // Update wishlist button state for new variant
             document.querySelector('wishlist-drawer')?.updateCardButtons();
          };

          // Handle loading state for ATC
          const clearATCLoading = () => {
             document.querySelectorAll('.cc-card__atc.is-loading').forEach(btn => {
                btn.classList.remove('is-loading');
             });
             // Also try to trigger a global resize or transition to refresh UI if needed
             window.dispatchEvent(new Event('resize'));
          };

          // Broad listener for all cart-related events to ensure spinner stops
          // We use both strings and ThemeEvents names if possible
          ['cart:update', 'cart:error', 'cart:add', 'cart:change', 'cart:success', 'cart:refresh'].forEach(ev => {
             document.addEventListener(ev, clearATCLoading);
          });

          document.addEventListener('submit', (e) => {
             const form = e.target;
             if (form.dataset.type === 'add-to-cart-form') {
                e.preventDefault();
                const btn = form.querySelector('.cc-card__atc');
                if (btn) {
                   btn.classList.add('is-loading');
                   // Safety timeout
                   setTimeout(clearATCLoading, 6000);
                }
             }
          });
       });
       window.customElementProductCardDefined = true;
    }

    /* ── DOM refs ───────────────────────────────────── */
    var grid = document.getElementById('cc-grid-' + SID);
    var emptyMsg = document.getElementById('cc-empty-' + SID);
    var resultEl = document.getElementById('cc-result-count-' + SID);
    var sidebarCountEl = document.getElementById('cc-count-' + SID);
    var activeEl = document.getElementById('cc-active-' + SID);

    if (!grid) return;

    var cards = Array.from(grid.querySelectorAll('.cc-card-wrap'));

    /* ── Accordion ──────────────────────────────────── */
    grid
      .closest('.cc-page')
      .querySelectorAll('[data-acc]')
      .forEach(function (btn) {
        btn.addEventListener('click', function () {
          var expanded = btn.getAttribute('aria-expanded') === 'true';
          btn.setAttribute('aria-expanded', !expanded);
          var body = btn.nextElementSibling;
          body.classList.toggle('cc-acc__body--open', !expanded);
        });
      });

    /* Open Sort by default */
    var firstAcc = grid.closest('.cc-page').querySelector('[data-acc]');
    

    /* ── Mobile toggle ──────────────────────────────── */
    var mobileBtn = document.getElementById('cc-filter-toggle-' + SID);
    var sidebar = document.getElementById('cc-sidebar-' + SID);
    if (mobileBtn && sidebar) {
      mobileBtn.addEventListener('click', function () {
        var open = mobileBtn.getAttribute('aria-expanded') === 'true';
        mobileBtn.setAttribute('aria-expanded', !open);
        sidebar.classList.toggle('cc-sidebar--open', !open);
      });
    }

    /* ── Sort ───────────────────────────────────────── */
    document.querySelectorAll('[data-sort]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (radio.checked) {
          state.sort = radio.value;
          applyFilters();
        }
      });
    });

    /* ── Size / Color checkboxes ─────────────────────── */
    grid
      .closest('.cc-page')
      .querySelectorAll('[data-filter-type="size"]')
      .forEach(function (cb) {
        cb.addEventListener('change', function () {
          if (cb.checked) {
            state.sizes.push(cb.value);
          } else {
            state.sizes = state.sizes.filter(function (s) {
              return s !== cb.value;
            });
          }
          applyFilters();
        });
      });

    grid
      .closest('.cc-page')
      .querySelectorAll('[data-filter-type="color"]')
      .forEach(function (cb) {
        cb.addEventListener('change', function () {
          if (cb.checked) {
            state.colors.push(cb.value);
          } else {
            state.colors = state.colors.filter(function (c) {
              return c !== cb.value;
            });
          }
          applyFilters();
        });
      });

    /* ── Price Range segments ───────────────────────── */
    grid
      .closest('.cc-page')
      .querySelectorAll('[data-filter-type="price-range"]')
      .forEach(function (cb) {
        cb.addEventListener('change', function () {
          if (cb.checked) {
            state.priceRanges.push(cb.value);
          } else {
            state.priceRanges = state.priceRanges.filter(function (r) {
              return r !== cb.value;
            });
          }
          applyFilters();
        });
      });

    /* ── Lowest Price checkbox ──────────────────────── */
    grid
      .closest('.cc-page')
      .querySelectorAll('[data-filter-type="lowest-price"]')
      .forEach(function (cb) {
        cb.addEventListener('change', function () {
          state.lowestPrice = cb.checked;
          applyFilters();
        });
      });

    /* ── Core filter + sort function ─────────────────── */
    function applyFilters() {
      var visible = cards.filter(function (card) {
        if (card.dataset.promo) return true;

        /* lowest price */
        if (state.lowestPrice) {
          if (card.dataset.lowestPrice !== 'true') return false;
        }

        /* price */
        var rawPrice = card.dataset.price || '0';
        var price = parseFloat(rawPrice.toString().replace(/[^0-9.]/g, '')) || 0;
        if (state.priceRanges.length > 0) {
          var inRange = state.priceRanges.some(function (r) {
            var bounds = r.split('-');
            var rMin = parseFloat(bounds[0]) * 100;
            var rMax = bounds[1] === 'plus' ? Infinity : parseFloat(bounds[1]) * 100;
            return price >= rMin && price <= rMax;
          });
          if (!inRange) return false;
        }

        /* size */
        if (state.sizes.length > 0) {
          var cardSizes = card.dataset.sizes || '';
          var hasSize = state.sizes.some(function (s) {
            return cardSizes.indexOf('|' + s + '|') > -1 || cardSizes.indexOf(s + '|') === 0;
          });
          if (!hasSize) return false;
        }

        /* color */
        if (state.colors.length > 0) {
          var cardColors = card.dataset.colors || '';
          var hasColor = state.colors.some(function (c) {
            return cardColors.toLowerCase().indexOf(c.toLowerCase()) > -1;
          });
          if (!hasColor) return false;
        }

        return true;
      });

      /* Sort & Interleave */
      var products = visible.filter(function (c) { return !c.dataset.promo; });
      var promos = visible.filter(function (c) { return !!c.dataset.promo; });

      products.sort(function (a, b) {
        var priceA = parseFloat((a.dataset.price || '0').toString().replace(/[^0-9.]/g, '')) || 0;
        var priceB = parseFloat((b.dataset.price || '0').toString().replace(/[^0-9.]/g, '')) || 0;

        if (state.sort === 'price-asc') {
          return priceA - priceB;
        } else if (state.sort === 'price-desc') {
          return priceB - priceA;
        } else if (state.sort === 'title-asc') {
          return (a.dataset.title || '').localeCompare(b.dataset.title || '');
        } else if (state.sort === 'title-desc') {
          return (b.dataset.title || '').localeCompare(a.dataset.title || '');
        } else if (state.sort === 'newest') {
          return (parseFloat(b.dataset.date) || 0) - (parseFloat(a.dataset.date) || 0);
        }
        return 0;
      });

      // Interleave promos back into products at distributed positions (approx every 5th)
      var sorted = [];
      var pIdx = 0;
      var mIdx = 0;
      while (pIdx < products.length || mIdx < promos.length) {
        if (mIdx < promos.length && (sorted.length % 5 === 2 || pIdx >= products.length)) {
          sorted.push(promos[mIdx++]);
        } else if (pIdx < products.length) {
          sorted.push(products[pIdx++]);
        } else {
          break;
        }
      }

      /* Hide all, then show sorted */
      cards.forEach(function (c) {
        c.classList.add('cc-hidden');
        grid.appendChild(c);
      });
      sorted.forEach(function (c) {
        c.classList.remove('cc-hidden');
        grid.insertBefore(c, grid.querySelector('.cc-empty'));
      });

      /* Empty state */
      if (emptyMsg) emptyMsg.hidden = sorted.length > 0;

      /* Count */
      if (resultEl) resultEl.textContent = sorted.length + ' results';
      // Sidebar count should match visible results, not total cached cards
      if (sidebarCountEl) sidebarCountEl.textContent = sorted.length + ' items';

      /* Active tags */
      renderActiveTags();

      /* Update URL */
      updateURL();
    }

    /* ── Active filter tags ──────────────────────────── */
    function renderActiveTags() {
      if (!activeEl) return;
      activeEl.innerHTML = '';

      if (
        state.sizes.length > 0 ||
        state.colors.length > 0 ||
        state.priceRanges.length > 0 ||
        state.lowestPrice
      ) {
        var clearBtn = document.createElement('button');
        clearBtn.id = 'cc-clear-' + SID;
        clearBtn.className = 'cc-clear-all';
        clearBtn.textContent = 'Clear all';
        clearBtn.addEventListener('click', clearAll);
        activeEl.appendChild(clearBtn);
      }

      state.sizes.forEach(function (s) {
        activeEl.appendChild(
          makeTag('Size: ' + s, function () {
            state.sizes = state.sizes.filter(function (x) {
              return x !== s;
            });
            grid
              .closest('.cc-page')
              .querySelectorAll('[data-filter-type="size"]')
              .forEach(function (cb) {
                if (cb.value === s) cb.checked = false;
              });
            applyFilters();
          })
        );
      });

      state.colors.forEach(function (c) {
        activeEl.appendChild(
          makeTag('Color: ' + c, function () {
            state.colors = state.colors.filter(function (x) {
              return x !== c;
            });
            grid
              .closest('.cc-page')
              .querySelectorAll('[data-filter-type="color"]')
              .forEach(function (cb) {
                if (cb.value === c) cb.checked = false;
              });
            applyFilters();
          })
        );
      });

      state.priceRanges.forEach(function (r) {
        var label = r.replace('-', ' - ');
        if (label.indexOf('plus') > -1) label = r.split('-')[0] + '+';
        activeEl.appendChild(
          makeTag('Price: ' + currency_symbol + label, function () {
            state.priceRanges = state.priceRanges.filter(function (x) {
              return x !== r;
            });
            grid
              .closest('.cc-page')
              .querySelectorAll('[data-filter-type="price-range"]')
              .forEach(function (cb) {
                if (cb.value === r) cb.checked = false;
              });
            applyFilters();
          })
        );
      });

      if (state.lowestPrice) {
        activeEl.appendChild(
          makeTag('Lowest Price', function () {
            state.lowestPrice = false;
            grid
              .closest('.cc-page')
              .querySelectorAll('[data-filter-type="lowest-price"]')
              .forEach(function (cb) {
                cb.checked = false;
              });
            applyFilters();
          })
        );
      }

    }

    function makeTag(text, onRemove) {
      var tag = document.createElement('span');
      tag.className = 'cc-filter-tag';
      tag.innerHTML = text + ' &times;';
      tag.addEventListener('click', onRemove);
      return tag;
    }

    function clearAll() {
      state.sizes = [];
      state.colors = [];
      state.priceRanges = [];
      state.lowestPrice = false;
      grid
        .closest('.cc-page')
        .querySelectorAll('[data-filter-type="size"],[data-filter-type="color"],[data-filter-type="price-range"],[data-filter-type="lowest-price"]')
        .forEach(function (cb) {
          cb.checked = false;
        });
      applyFilters();
    }

    function initScrollSlider(type, sid) {
      var track = document.getElementById('cc-' + type + '-track-' + sid);
      var prev = document.getElementById('cc-' + type + '-prev-' + sid);
      var next = document.getElementById('cc-' + type + '-next-' + sid);
      if (!track || !prev || !next) return;

      var step = function () {
        var first = track.firstElementChild;
        return first ? first.offsetWidth + 12 : 160;
      };

      prev.onclick = function () {
        track.scrollBy({ left: -step() * 2, behavior: 'smooth' });
      };
      next.onclick = function () {
        track.scrollBy({ left: step() * 2, behavior: 'smooth' });
      };

      var update = function () {
        if (track.scrollLeft <= 5) prev.classList.remove('is-visible');
        else prev.classList.add('is-visible');

        if (track.scrollLeft + track.offsetWidth >= track.scrollWidth - 5) next.classList.remove('is-visible');
        else next.classList.add('is-visible');
      };

      track.onscroll = update;
      window.addEventListener('resize', update);
      setTimeout(update, 200);
    }

    /* ── Infinite scroll (section fetch) ── */
    var loadMoreEl = document.getElementById('cc-load-more-' + SID);
    var loadMoreWrap = document.getElementById('cc-load-more-wrap-' + SID);
    var infiniteSentinel = document.getElementById('cc-infinite-sentinel-' + SID);
    var loadMoreLabel = loadMoreEl ? loadMoreEl.querySelector('.cc-infinite-scroll__label') : null;
    var scrollLoading = false;
    var infiniteScrollObserver = null;

    function disconnectInfiniteScroll() {
      if (infiniteScrollObserver) {
        infiniteScrollObserver.disconnect();
        infiniteScrollObserver = null;
      }
    }

    function loadMoreCards() {
      if (scrollLoading) return;
      if (!loadMoreEl || !loadMoreWrap || !loadMoreWrap.parentNode) return;

      var url = loadMoreEl.getAttribute('data-url');
      if (!url || url === '' || url === 'null') {
        disconnectInfiniteScroll();
        if (loadMoreWrap.parentNode) loadMoreWrap.remove();
        return;
      }

      scrollLoading = true;
      loadMoreEl.classList.add('is-loading');
      if (loadMoreLabel) loadMoreLabel.textContent = 'Loading...';

      var sectionUrl = new URL(url, window.location.origin);
      sectionUrl.searchParams.set('section_id', SID);

      fetch(sectionUrl.toString())
        .then(function (res) {
          return res.text();
        })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newGrid = doc.getElementById('cc-grid-' + SID);

          if (!newGrid) {
            loadMoreEl.classList.remove('is-loading');
            if (loadMoreLabel) loadMoreLabel.textContent = '';
            return;
          }

          var newCards = Array.from(newGrid.querySelectorAll('.cc-card-wrap'));
          var nextStatus = doc.getElementById('cc-load-more-' + SID);

          newCards.forEach(function (card) {
            grid.insertBefore(card, emptyMsg);
            cards.push(card);
          });

          if (nextStatus) {
            var nextUrl = nextStatus.getAttribute('data-url') || '';
            if (
              (!nextUrl || nextUrl === '' || nextUrl === 'null')
            ) {
              disconnectInfiniteScroll();
              loadMoreWrap.remove();
              applyFilters();
              return;
            }
            loadMoreEl.setAttribute('data-url', nextUrl);
            loadMoreEl.classList.remove('is-loading');
            if (loadMoreLabel) loadMoreLabel.textContent = '';
          } else {
            disconnectInfiniteScroll();
            loadMoreWrap.remove();
          }

          applyFilters();
        })
        .catch(function (err) {
          console.error('Error loading more products:', err);
          if (loadMoreEl && loadMoreEl.parentNode) {
            loadMoreEl.classList.remove('is-loading');
            if (loadMoreLabel) loadMoreLabel.textContent = '';
          }
        })
        .finally(function () {
          scrollLoading = false;
        });
    }

    if (infiniteSentinel && loadMoreWrap && loadMoreEl) {
      infiniteScrollObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            if (!loadMoreWrap || !loadMoreWrap.parentNode) return;
            loadMoreCards();
          });
        },
        { root: null, rootMargin: '240px 0px 0px 0px', threshold: 0 }
      );
      infiniteScrollObserver.observe(infiniteSentinel);
    }

    /* Initial render */
    syncStateFromDOM();
    syncStateFromURL();
    applyFilters();
    initScrollSlider('sub', SID);
    initScrollSlider('rel', SID);
    initScrollSlider('rel-top', SID);
  })();
  /* ── Variant Thumbs: Show More / Less ───────────────────────── */
  (function () {
    function initThumbCollapse(card) {
      var wrap = card.querySelector('[data-thumb-wrap]');
      var toggle = card.querySelector('[data-thumb-toggle]');
      if (!wrap || !toggle) return;

      var thumbs = Array.from(wrap.querySelectorAll('.cc-card__thumb'));
      if (thumbs.length === 0) return;

      function collapse() {
        /* Reset first */
        thumbs.forEach(function (t) { t.classList.remove('cc-card__thumb--hidden'); });
        toggle.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
        var more = toggle.querySelector('.cc-thumbs-toggle__more');
        var less = toggle.querySelector('.cc-thumbs-toggle__less');
        if (more) more.hidden = false;
        if (less) less.hidden = true;

        /* Measure on next frame to ensure layout is ready */
        requestAnimationFrame(function() {
          if (thumbs.length === 0) return;
          var firstTop = thumbs[0].getBoundingClientRect().top;
          var cutIndex = -1;
          for (var i = 1; i < thumbs.length; i++) {
            if (Math.round(thumbs[i].getBoundingClientRect().top) > Math.round(firstTop) + 4) {
              cutIndex = i;
              break;
            }
          }

          if (cutIndex === -1) return; /* All thumbs fit in one row */

          /* Hide excess thumbs */
          for (var j = cutIndex; j < thumbs.length; j++) {
            thumbs[j].classList.add('cc-card__thumb--hidden');
          }
          var hiddenCount = thumbs.length - cutIndex;
          toggle.hidden = false;
          var moreLabel = toggle.querySelector('.cc-thumbs-more-label');
          if (moreLabel) moreLabel.textContent = '+' + hiddenCount + ' more';
        });
      }

      collapse();

      toggle.onclick = function (e) {
        e.preventDefault(); e.stopPropagation();
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        var more = toggle.querySelector('.cc-thumbs-toggle__more');
        var less = toggle.querySelector('.cc-thumbs-toggle__less');
        if (!expanded) {
          /* Show all */
          thumbs.forEach(function (t) { t.classList.remove('cc-card__thumb--hidden'); });
          toggle.setAttribute('aria-expanded', 'true');
          if (more) more.hidden = true;
          if (less) less.hidden = false;
        } else {
          /* Collapse back to one row */
          collapse();
        }
      };
    }

    function initAllThumbs() {
      document.querySelectorAll('.cc-card--premium').forEach(function (card) {
        if (!card.dataset.thumbInit) {
          card.dataset.thumbInit = '1';
          initThumbCollapse(card);
        }
      });
    }

    document.addEventListener('DOMContentLoaded', initAllThumbs);
    window.addEventListener('resize', function() {
       document.querySelectorAll('.cc-card--premium').forEach(function(c) {
          if (c.querySelector('[data-thumb-toggle]')?.getAttribute('aria-expanded') !== 'true') {
             delete c.dataset.thumbInit;
          }
       });
       initAllThumbs();
    });
    document.addEventListener('shopify:section:load', initAllThumbs);
    window.addEventListener('load', initAllThumbs);
    setTimeout(initAllThumbs, 1000);
    setTimeout(initAllThumbs, 3000);
  })();
  /* ── ATC Success State + Toast ── */
  (function () {
    /* Inject global toast container once */
    function getToastContainer() {
      var c = document.getElementById('cc-toast-container');
      if (!c) {
        c = document.createElement('div');
        c.id = 'cc-toast-container';
        document.body.appendChild(c);
      }
      return c;
    }

    

    function triggerSuccess(btn) {
      var productTitle = btn.getAttribute('data-product-title') || 'Product';
      btn.classList.add('is-success');
      btn.setAttribute('aria-label', 'Added to cart');
      
      setTimeout(function () {
        btn.classList.remove('is-success');
        btn.setAttribute('aria-label', 'Add to cart');
      }, 4000);
    }

    function watchBtn(btn) {
      if (btn._ccSuccessWatched) return;
      btn._ccSuccessWatched = true;
      var wasLoading = false;
      var observer = new MutationObserver(function () {
        var isLoading = btn.classList.contains('is-loading');
        if (!wasLoading && isLoading) {
          wasLoading = true;
        } else if (wasLoading && !isLoading) {
          wasLoading = false;
          /* Small delay to let any error class be added first */
          setTimeout(function () {
            var hasError = btn.closest('[data-type="add-to-cart-form"]')
              ? btn.closest('[data-type="add-to-cart-form"]').querySelector('.product-form__error-message:not(.hidden)')
              : null;
            if (!hasError) {
              triggerSuccess(btn);
            }
          }, 50);
        }
      });
      observer.observe(btn, { attributes: true, attributeFilter: ['class'] });
    }

    function watchAll() {
      document.querySelectorAll('.cc-card__atc').forEach(watchBtn);
    }

    document.addEventListener('DOMContentLoaded', watchAll);
    document.addEventListener('shopify:section:load', watchAll);

    /* Watch for dynamically injected cards (load-more) */
    var domObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('.cc-card__atc')) { watchBtn(node); }
          node.querySelectorAll && node.querySelectorAll('.cc-card__atc').forEach(watchBtn);
        });
      });
    });
    domObserver.observe(document.body, { childList: true, subtree: true });
  })();
